import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import { CLEARED_ONLY_STATUSES } from '@/services/paymentStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'DepositsTab',
  props: {
    tabId: {}
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PaymentsTableTab, {
    "base-statuses": _unref(CLEARED_ONLY_STATUSES),
    "empty-description": "No deposits match your current filters.",
    "process-date-header": "Cleared Date"
  }, null, 8, ["base-statuses"]))
}
}

})